import { render } from "./Team_operation_en.vue?vue&type=template&id=70048c16&scoped=true"
import script from "./Team_operation_en.vue?vue&type=script&lang=js"
export * from "./Team_operation_en.vue?vue&type=script&lang=js"

import "./Team_operation_en.vue?vue&type=style&index=0&id=70048c16&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-70048c16"

export default script